import { useEffect, useState } from "react";
import { apiJson } from "../dependencies/api.ts";
import { useMessageHandler } from "../context/MessageContext.tsx";

export const useResistorOptions = () => {
  const [options, setOptions] = useState<number[]>([]);
  const { handle } = useMessageHandler();

  useEffect(() => {
    handle(async () => {
      const response = await apiJson.get("/electronics/resistorOptions");
      setOptions(response.data);
    });
  }, [handle]);

  return { options };
};